import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { UserValidators } from '@app/classes/user-validators.class';
import { MustMatchForm2 } from '@app/helpers/must-match-form.validator';
import { TextValidators } from '@app/services/validators/password.validator';
import { PATTERNS } from '@app/constants';
import { AuthService } from '@app/services';

@Component({
   templateUrl: './authentication-reset-password.component.html',
   styleUrls: ['./authentication-reset-password.component.scss']
})
export class AuthenticationResetPasswordComponent implements OnInit {

   passwordBlur = false;

   passwordFlag: 'text' | 'password' = 'password';
   passwordFlag2: 'text' | 'password' = 'password';

   token: string;
   email: string;

   resetPassForm: FormGroup;

   constructor(
      private dialog: MatDialogRef<AuthenticationResetPasswordComponent>,
      private authServ: AuthService,
      private router: Router,
      private toastr: ToastrService) { }

   ngOnInit(): void {
      this.resetPassForm = new FormGroup({
         password: new FormControl('', [
            Validators.required,
            Validators.minLength(8),
            TextValidators.password,
            UserValidators.patternValidator(PATTERNS.passwords, { validPassword: false }),]),
         confirmPassword: new FormControl('', [
            Validators.required,
            Validators.minLength(8),
         ]),
      }, {
         validators: [MustMatchForm2('password', 'confirmPassword', 'notMatchPass')]
      })
   }

   ngAfterViewInit(): void {
      Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(tooltipNode => new Tooltip(tooltipNode));
   }

   resetUserPassword() {
      if (this.resetPassForm.valid) {
         const newPass = this.resetPassForm.controls['password'].value as string;

         this.authServ.resetUserPassword(this.token, this.email, newPass).subscribe({
            next: () => {
               this.passwordBlur = false;
               document.getElementsByClassName('tooltip bs-tooltip-auto')[0]?.classList.remove('show');
               this.router.navigate(['/']);
               this.toastr.success('Se ha cambiado la contraseña exitosamente.');
               this.close();
            }
         });
      }
   }

   close() {
      this.dialog.close()
   }

}
